module.exports = {"productSearchBoxTitle":"Wyszukaj artykuł","productSearchBoxPlaceholder":"Nazwa, kod EAN lub kod artykułu","searchButtonText":"Szukaj","pickerChangeProductBtn":"Edytuj","pickerInputPlaceholder":"Produkt","pickerProductInputLabel":"Produkt *"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Product/translate.json
// module id = 457
// module chunks = 0